import { createKeyedSignal } from "@react-rxjs/utils"
import { concat, filter, map, merge, pipe, take } from "rxjs"

import { currencyPairs$ } from "@/services/currencyPairs"
import { formatNotional } from "@/utils/formatNotional"

import { symbolBind } from "../TileContext"

const MAX_NOTIONAL = 1_000_000_000

const [rawNotional$, onChangeNotionalValue] = createKeyedSignal(
  (x) => x.symbol,
  (symbol: string, rawVal: string) => ({ symbol, rawVal }),
)

export const [useNotional, getNotional$] = symbolBind((symbol) =>
  concat(
    currencyPairs$.pipe(
      take(1),
      map((ccPairs) => ({
        symbol,
        rawVal: ccPairs[symbol].defaultNotional.toString(),
      })),
    ),
    rawNotional$(symbol),
  ).pipe(
    map(({ rawVal }) => formatNotional(rawVal, ["k", "m"])),
    filter(([value]) => !Number.isNaN(value)),
  ),
)
export const [, getNotionalValue$] = symbolBind(
  pipe(
    getNotional$,
    map(([value]) => value),
  ),
)

export const [useIsNotionalValid] = symbolBind(
  pipe(
    getNotionalValue$,
    map((value) => value <= MAX_NOTIONAL),
  ),
  true,
)

const [useDefaultNotional, defaultNotional$] = symbolBind((symbol) =>
  currencyPairs$.pipe(map((pairs) => pairs[symbol].defaultNotional)),
)

export { onChangeNotionalValue, useDefaultNotional }

export const notionalInput$ = (symbol: string) =>
  merge(...[defaultNotional$, getNotional$].map((fn) => fn(symbol)))
